import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    SubscriptionSetting
} from "../models";

/**
 * @class SubscriptionSettingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<City>}
 */
export class SubscriptionSettingPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/subscription-setting(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {SubscriptionSetting}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SubscriptionSetting(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<SubscriptionSetting>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }


    /**
     * @param {M|SubscriptionSetting} setting
     * @returns {Promise.<SubscriptionSetting>}
     */
    update(setting) {

        const url = this.url({
            id: setting.id
        });

        return this.http
            .put(url, setting, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/subscription-setting.service.js